import React from 'react';
import { CheckIcon, ChevronRightIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { MOCKUP_URL, pathwayChips } from '../../data/content';
const trust = ['Instant Digital Access', 'Practical Checklists & Planning Templates', 'Designed for Qualified Pediatric Professionals', '7-Day Money-Back Guarantee'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy text-white" data-id="element-185" data-mp="mu0ngkxdhhrz">
      <div className="bg-accent py-2 text-center text-[13px] font-bold text-white sm:text-sm" data-id="element-186" data-mp="mtsc4xgwekiw">
        Launch price today: complete blueprint for just $27
      </div>
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-8 sm:pt-12 lg:grid lg:grid-cols-2 lg:items-center lg:gap-12 lg:pb-20" data-id="element-187" data-mp="vndpccdeztq7">
        <div className="text-center lg:text-left" data-id="element-188" data-mp="10knkm8nhizly">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-brand-soft" data-id="element-189" data-mp="15l1u7v4qihm3">Pediatric Motor Planning Blueprint™</p>
          <p className="mt-2 text-[15px] text-white/75" data-id="element-190" data-mp="1ajuzj09vb2b6">A Practical Clinical Planning System for Pediatric Occupational Therapists</p>
          <h1 className="mt-5 font-display text-[30px] font-extrabold leading-[1.12] sm:text-5xl" data-id="element-191" data-mp="4opuicfw2b8v">
            Turn Pediatric Motor Planning Observations Into a{' '}
            <span className="text-accent" data-id="element-192" data-mp="3vvaqmaksw9cr">Structured, 5-Part Intervention Plan</span> — Using One Practical Clinical Workflow.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-193" data-mp="se0xm0kpohq6">
            Stop piecing together scattered assessment notes, disconnected therapy activities, and unclear treatment goals.
          </p>
        </div>

        <div className="mt-8 lg:mt-0" data-id="element-194" data-mp="in6bqxbdnk59">
          <img src={MOCKUP_URL} alt="Pediatric Motor Planning Blueprint — 6 volumes and 5 bonuses" className="mx-auto w-full max-w-[560px] drop-shadow-2xl" data-id="element-195" data-mp="im4m9ntm6v40" />
        </div>

        <div className="lg:col-span-2" data-id="element-196" data-mp="1b6cwgdc5p0vk">
          <div className="mx-auto mt-8 max-w-3xl rounded-2xl bg-navy-mid p-5" data-id="element-197" data-mp="16e3dxiddf33b">
            <p className="text-center text-sm text-white/80" data-id="element-198" data-mp="16bz1ud5bixry">
              With the <strong className="text-white" data-id="element-199" data-mp="30mfke0jea7iv">PEDIATRIC MOTOR PLANNING PATHWAY™</strong>, organize your observations into five essential planning components:
            </p>
            <ol className="mt-4 flex flex-wrap items-center justify-center gap-x-1 gap-y-2" data-id="element-200" data-mp="2qww0qsnuy9my">
              {pathwayChips.map((c, i) => <li key={c} className="flex items-center gap-1" data-id="element-201" data-mp="2vte35lvptvw4" data-mpi={i}>
                  <span className="rounded-full bg-brand px-3 py-1.5 text-[13px] font-bold text-white" data-id="element-202" data-mp="2huedcawgvayd">{c}</span>
                  {i < pathwayChips.length - 1 && <ChevronRightIcon className="h-4 w-4 text-brand-soft" aria-hidden="true" data-id="element-203" data-mp="2msfvmtm2j68s" />}
                </li>)}
            </ol>
            <p className="mt-4 text-center text-sm text-white/75" data-id="element-204" data-mp="2cvjlkjgiuc24">
              Build a case-specific planning document that connects what you observe with what you plan, document, and monitor.
            </p>
          </div>

          <p className="mt-8 text-center font-display text-lg font-extrabold" data-id="element-205" data-mp="b4g8zon2mnex">
            6 Practical Volumes + 5 Clinical Planning Bonuses
          </p>
          <p className="mt-1 text-center text-white/80" data-id="element-206" data-mp="1qo7cfykkfxwp">
            Get the Complete Blueprint for Just <span className="font-display text-2xl font-extrabold text-accent" data-id="element-207" data-mp="25ck2yg0vwojt">$27</span>
          </p>

          <div className="mt-5 flex justify-center" data-id="element-208" data-mp="20mdf4ie7582m">
            <CTAButton id="hero-cta" label="Build My Motor Planning Workflow" sublabel="Get instant access — $27" data-id="element-209" data-mp="20kskksrvtp4r" />
          </div>

          <ul className="mx-auto mt-6 grid max-w-3xl grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-210" data-mp="2abwyrq9qh5yj">
            {trust.map(t => <li key={t} className="flex items-center gap-2 text-sm text-white/85" data-id="element-211" data-mp="2oc7ogpzb4ei4">
                <CheckIcon className="h-4 w-4 shrink-0 text-brand-soft" aria-hidden="true" data-id="element-212" data-mp="2jcuw5ppo2f85" />
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}